export default __webpack_public_path__ + "static/media/IMG_5024.43cdf3c9.png";